module.exports = __webpack_public_path__ + "img/ont.d3eaadb3.svg";